import { Provider } from 'react-redux';

import F2AppclassFactory from '../utils/f2AppclassFactory';
import Component from '../components/apps/screener';
import store from '../stores/screener/screener-redux-store';

F2AppclassFactory.create({
  Component,
  appId: 'screener',
  contextProperties: ['channel', 'yyy', 'Plans', 'UrlDomain', 'UrlPrefix', 'bluetagcharacteristic'],
  Redux: { Provider, store }
});
